import { render } from "./RegistrationsTable.vue?vue&type=template&id=504eccce&ts=true"
import script from "./RegistrationsTable.vue?vue&type=script&lang=ts"
export * from "./RegistrationsTable.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./RegistrationsTable.vue?vue&type=style&index=0&id=504eccce&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QTable,QTd,QBadge,QInput,QPopupProxy,QDate,QIcon});
